<div>
  <fou-group>
    <p class="mt-h3">Check Bulk Import Status</p>
    <p class="mt-serif mt-serif--size4"></p>
  </fou-group>

  <section class="mt-section mt-section--bottom-large">
    <span class="mt-serif mt-serif--size10" style="vertical-align: middle; padding: 20px;">TempImportVersion:</span>
    <input class="mt-input" type="number" v-model="mdlTempImportVersion" style="vertical-align: middle;" @keydown="preventE($event)" @keyup.enter="fetchBulkImportStatus()"/>
    <button type="button" class="mt-button" @click="fetchBulkImportStatus()" style="vertical-align: middle;" :class="$style.bulkButton">Check</button>
    <button v-if="showBulkImportStatus" type="button" class="mt-button mt-button--red" @click="clear()" style="vertical-align: middle;" :class="$style.bulkButton">Back</button>
    <p v-if="valError" class="mt-error" style="padding-left: 20px">{{valError}}</p>
  </section>

  <section v-if="showBulkImportStatus" class="mt-section mt-section--bottom-large">
    <div :class="$style.uploaderProcessing" v-if="loading">
      <animation-processing :class="$style.spinner"></animation-processing>
    </div>
    <div v-if="errorMessage">
      <p class="mt-h6">Error occurred while retrieving bulk import status:</p>
      <div class="row" style="padding: 10px">
        <div class="col is3">
          <p class="mt-serif--bold">TempImportVersion:</p>
        </div>
        <div class="col is9">
          <p class="mt-serif">{{ searchedTempImportVersion }}</p>
        </div>
      </div>

      <div class="row" style="padding: 10px">
        <div class="col is3">
          <p class="mt-serif--bold">Error:</p>
        </div>
        <div class="col is9">
          <p class="mt-serif">{{ errorMessage }}</p>
        </div>
      </div>
    </div>
    <div v-else-if="bulkImportStatus">
      <p class="mt-h4">Bulk Import Status</p>
      <div style="padding-bottom: 20px;">
        <div class="row" style="padding: 10px">
          <div class="col is3">
            <p class="mt-serif--bold">TempImportVersion:</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{ bulkImportStatus.tempImportVersion }}</p>
          </div>
        </div>
        <div class="row" style="padding: 10px">
          <div class="col is3">
            <p class="mt-serif--bold">Submitted by</p>
          </div>
          <div class="col is9">
            <p class="mt-serif">{{ bulkImportStatus.owner}}</p>
          </div>
        </div>

        <div class="row" style="padding: 10px">
          <div class="col is3">
            <p class="mt-serif--bold">Overall status</p>
          </div>
          <div class="col is9" v-if="bulkImportStatus.message">
            <p class="mt-serif">{{simplifyMessages(bulkImportStatus.message)}}</p>
          </div>
        </div>
      </div>

      <fou-group v-if="bulkImportStatus.importStatus && (bulkImportStatus.importStatus.length > 0)">
        <fou-container :id="$vId(this, 'bulk-import-status')" cols="12">
          <template #content>
          <div>
            <v-grid
              element="ul"
              class="mt-list"
              :class="$style.listHeader">
              <v-row
                element="li"
                class="mt-list-item">
                <v-col has="2">
                  <span class="mt-label mt-label--capitalise mt-label--greylabel" :class="$style.headerItem">Foundry</span>
                </v-col>
                <v-col has="3">
                  <span class="mt-label mt-label--capitalise mt-label--greylabel" :class="$style.headerItem">Family</span>
                </v-col>
                <v-col has="7">
                  <span class="mt-label mt-label--capitalise mt-label--greylabel" :class="$style.headerItem">Message</span>
                </v-col>
              </v-row>
            </v-grid>

            <div :class="$style.families">
              <div :id="$vId(this, 'families')" :class="$style.familiesInside">
                <v-grid
                  element="ul">
                  <v-row
                    v-for="importedFamily, key in bulkImportStatus.importStatus"
                    :key="key"
                    element="li"
                    class="mt-list-item listItem"
                    :class="$style.listItem">
                    <v-col has="2">
                      <div class="mt-serif mt-serif--size8" style="padding-left: 20px;">
                        {{importedFamily.foundryName}}
                      </div>
                    </v-col>
                    <v-col has="3">
                      <div class="out-right mt-serif mt-serif--size8" style="padding-left: 20px;">
                        {{importedFamily.familyName}}
                      </div>
                    </v-col>
                    <v-col has="7">
                      <div v-if="!(importedFamily.errorMessage)&&(importedFamily.familyUpdate)" class="mt-serif mt-serif--size8" style="padding-left: 20px;color:green;">
                        {{$t('pages.bulk_import.update_success')}}
                      </div>
                      <div v-else-if="!(importedFamily.errorMessage)" class="mt-serif mt-serif--size8" style="padding-left: 20px;color:green;">
                        {{$t('pages.bulk_import.insert_success')}}
                      </div>
                      <div v-else class="mt-serif mt-serif--size8" style="padding-left: 20px;color:red;">
                        {{simplifyMessages(importedFamily.errorMessage)}}
                      </div>
                    </v-col>
                  </v-row>
                </v-grid>
              </div>
            </div>
          </div>
        </template>

        </fou-container>

      </fou-group>

    </div>
  </section>

</div>
